import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { format, addDays, startOfWeek, endOfWeek } from 'date-fns';
import Swal from 'sweetalert2';
import { AgendaService } from '../../services/agenda/agenda.service';


@Component({
  selector: 'app-agenda',
  standalone: true,
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss'],
  imports: [CommonModule]
})
export class AgendaComponent implements OnInit {

  diaDeHoje: string = '';
  eventos: any[] = [];
  timeSlots: string[] = ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00'];

  constructor(private agendaService: AgendaService) {}

  ngOnInit() {
    const hoje = new Date();
    this.diaDeHoje = format(hoje, "d 'de' MMMM 'de' yyyy");
  }

  private showNoEventsAlert(): void {
    Swal.fire({
      icon: 'info',
      title: 'Nenhum evento encontrado',
      text: 'Nenhum evento encontrado para o período selecionado.',
      confirmButtonText: 'OK'
    });
  }

  filtrarHoje() {
    const hoje = new Date();
    const dataFormatada = format(hoje, 'yyyy-MM-dd');

    this.agendaService.getEventos(dataFormatada, dataFormatada).subscribe(res => {
      this.eventos = res.formatoArquivos || [];
      if (this.eventos.length === 0) {
        this.showNoEventsAlert();
      }
    });
  }

  filtrarAmanha() {
    const amanha = addDays(new Date(), 1);
    const dataFormatada = format(amanha, 'yyyy-MM-dd');

    this.agendaService.getEventos(dataFormatada, dataFormatada).subscribe(res => {
      this.eventos = res.formatoArquivos || [];
      if (this.eventos.length === 0) {
        this.showNoEventsAlert();
      }
    });
  }

  filtrarFinalDeSemana() {
    // Exemplo: sábado e domingo da semana atual
    const hoje = new Date();
    const diaSemana = hoje.getDay();
    const diasParaSabado = (6 - diaSemana + 7) % 7; // ajusta para sábado
    const sabado = addDays(hoje, diasParaSabado);
    const domingo = addDays(sabado, 1);
    const datInicial = format(sabado, 'yyyy-MM-dd');
    const datFinal = format(domingo, 'yyyy-MM-dd');

    this.agendaService.getEventos(datInicial, datFinal).subscribe(res => {
      this.eventos = res.formatoArquivos || [];
      if (this.eventos.length === 0) {
        this.showNoEventsAlert();
      }
    });
  }

  filtrarMes() {
    const hoje = new Date();
    const inicioMes = format(new Date(hoje.getFullYear(), hoje.getMonth(), 1), 'yyyy-MM-dd');
    const fimMes = format(new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0), 'yyyy-MM-dd');

    this.agendaService.getEventos(inicioMes, fimMes).subscribe(res => {
      this.eventos = res.formatoArquivos || [];
      if (this.eventos.length === 0) {
        this.showNoEventsAlert();
      }
    });
  }

  // Exemplo de método para mapear os eventos para cada time-slot
  getEventosDoSlot(slot: string) {
    return this.eventos.filter(evento => {
      if (evento.dscHoraInicioEvento) {
        return evento.dscHoraInicioEvento.startsWith(slot);
      }
      return false;
    });
  }
}
